import React, { useState } from "react";
import styled from "styled-components";

const GuessTheNumber: React.FC = () => {
  const [userGuess, setUserGuess] = useState<number | string>("");
  const [feedback, setFeedback] = useState<string>("");
  const [attempts, setAttempts] = useState<number>(0);
  const [numberToGuess, setNumberToGuess] = useState<number>(
    Math.floor(Math.random() * 100) + 1
  );
  const [gameOver, setGameOver] = useState<boolean>(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserGuess(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const guess = Number(userGuess);

    if (isNaN(guess) || guess < 1 || guess > 100) {
      setFeedback("Por favor, insira um número válido entre 1 e 100.");
      return;
    }

    setAttempts(attempts + 1);

    if (guess > numberToGuess) {
      setFeedback("Muito alto! Tente um número menor.");
    } else if (guess < numberToGuess) {
      setFeedback("Muito baixo! Tente um número maior.");
    } else {
      setFeedback(`Parabéns! Você acertou em ${attempts + 1} tentativas!`);
      setGameOver(true);
    }

    setUserGuess("");
  };

  const restartGame = () => {
    setGameOver(false);
    setAttempts(0);
    setFeedback("");
    setNumberToGuess(Math.floor(Math.random() * 100) + 1);
    setUserGuess("");
  };

  return (
    <Container>
      <ContentWrapper>
        <Title>Adivinha o Número!</Title>
        <Subtitle>Tente adivinhar o número entre 1 e 100.</Subtitle>
        <Form onSubmit={handleSubmit}>
          <Input
            type="number"
            value={userGuess}
            onChange={handleInputChange}
            disabled={gameOver}
            placeholder="Digite um número"
          />
          <Button type="submit" disabled={gameOver}>
            Submeter
          </Button>
        </Form>
        <Feedback>{feedback}</Feedback>
        {gameOver && <RestartButton onClick={restartGame}>Jogar Novamente</RestartButton>}
      </ContentWrapper>
    </Container>
  );
};

export default GuessTheNumber;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f8f9fa;
  padding: 2rem;
  text-align: center;
`;

const ContentWrapper = styled.div`
  max-width: 500px;
  padding: 2rem;
  background: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`;

const Title = styled.h1`
  font-size: 2rem;
  color: #2a5298;
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 1.5rem;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Input = styled.input`
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  text-align: center;
`;

const Button = styled.button`
  padding: 10px;
  font-size: 1rem;
  color: white;
  background-color: #2a5298;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background-color: #1e3c72;
  }

  &:disabled {
    background-color: #bbb;
    cursor: not-allowed;
  }
`;

const Feedback = styled.p`
  font-size: 1.2rem;
  color: #ff5722;
  margin-top: 1rem;
`;

const RestartButton = styled(Button)`
  background-color: #ff9800;
  margin-top: 1rem;

  &:hover {
    background-color: #e68900;
  }
`;
